/* LOGAN "white" product concept. Vanilla JS, no dependencies.
   Loaded (deferred) by every lw-* section; the guard below makes repeat loads a no-op. */
(function () {
  'use strict';
  if (window.LW) return;
  var LW = (window.LW = {});

  var doc = document;
  // QA override: ?lw_motion=on ignores prefers-reduced-motion (for testing on machines with animations turned off).
  var forceMotion = /[?&]lw_motion=on(?:&|$)/.test(window.location.search);
  var reduce = !forceMotion && !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;
  if (hasIO && !reduce) doc.documentElement.classList.add('lw-anim');

  function all(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function once(el, key) {
    var k = 'lwInit' + key; // -> data-lw-init-<key>, never collides with the data-lw-* hooks

    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- reveal on scroll ---------- */
  var revealIO = hasIO && !reduce
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;
  function initReveal(root) {
    all('[data-lw-reveal]', root).forEach(function (el) {
      if (!once(el, 'Reveal')) return;
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- play() that keeps the poster: when the browser refuses playback (iOS Low Power Mode, data saver)
     the element gets .is-noplay and lw.css hides it, so the eager poster behind it (.lw-ben__poster) shows ---------- */
  function tryPlay(v) {
    var p = v.play();
    if (p && p.then) {
      p.then(function () { v.classList.remove('is-noplay'); }, function (err) {
        if (err && err.name === 'NotAllowedError') v.classList.add('is-noplay');
      });
    }
  }

  /* ---------- autoplay muted videos only while visible ---------- */
  var videoIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && !v.dataset.lwUserPaused && !v.dataset.lwOffslide) {
            tryPlay(v);
          } else if (!e.isIntersecting) {
            v.pause();
          }
        });
      }, { threshold: 0.4 })
    : null;
  function setPoster(v) {
    var p = v.getAttribute('data-lw-poster');
    if (!p) return;
    v.poster = p;
    v.removeAttribute('data-lw-poster');
  }
  // round 15: videos inside a swipe row ([data-lw-row]) get their posters together when the row nears the viewport:
  // the viewport margin cannot reach cards clipped off to the side of an overflow-x row
  var posterIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          (e.target._lwPosterVids || [e.target]).forEach(setPoster);
          posterIO.unobserve(e.target);
        });
      }, { rootMargin: '600px 0px' })
    : null;
  function lazyPosters(root) {
    all('video[data-lw-poster]', root).forEach(function (v) {
      if (!posterIO) { setPoster(v); return; }
      var row = v.closest('[data-lw-row]');
      if (!row) { posterIO.observe(v); return; }
      if (!row._lwPosterVids) { row._lwPosterVids = []; posterIO.observe(row); }
      if (row._lwPosterVids.indexOf(v) < 0) row._lwPosterVids.push(v);
    });
  }
  function watchVideo(v) {
    if (!once(v, 'Video')) return;
    v.muted = true;
    if (videoIO) videoIO.observe(v);
  }

  /* ---------- play-once clips ([data-lw-once]): play when half in view, rest on the last frame,
     restart on every new entry; desktop hover replays. Product clips play under reduced motion too (owner's call,
     2026-10-05: small muted in-card loops); big motion (reveals, Ken Burns, nudges) stays reduced ---------- */
  function replay(v) {
    try { v.currentTime = parseFloat(v.getAttribute('data-lw-start')) || 0; } catch (err) {}
    tryPlay(v);
  }
  var onceIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) replay(e.target);
          else e.target.pause();
        });
      }, { threshold: 0.5 })
    : null;
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function initOnce(root) {
    all('video[data-lw-once]', root).forEach(function (v) {
      if (!once(v, 'Once')) return;
      v.muted = true;
      if (onceIO) onceIO.observe(v);
      if (canHover) {
        var card = v.closest('.lw-card') || v.parentNode;
        card.addEventListener('mouseenter', function () { if (v.paused || v.ended) replay(v); });
      }
    });
  }

  /* ---------- swipe carousel (mobile benefit cards): the IOs above use the viewport as root and are clipped by the
     overflow-x scroller; as a backup, re-check the clips once each swipe settles and start any that are on screen ---------- */
  function initSwipePlay(root) {
    all('.lw-ben__grid--media, .lw-ugc__track', root).forEach(function (grid) {
      if (!once(grid, 'Swipe')) return;
      var t = 0;
      grid.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var g = grid.getBoundingClientRect();
          all('video', grid).forEach(function (v) {
            if (v.closest('[hidden]') || !v.paused || v.ended || v.dataset.lwUserPaused) return;
            var r = v.getBoundingClientRect();
            if (!r.width || !r.height) return;
            var w = Math.min(r.right, g.right, window.innerWidth) - Math.max(r.left, g.left, 0);
            var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
            if (w < r.width * 0.5 || h < r.height * 0.4) return;
            if (!v.hasAttribute('data-lw-once')) tryPlay(v);
            else if (v.currentTime < 0.1) replay(v);  // a clip that never started; finished clips rest on their last frame
          });
        }, 160);
      }, { passive: true });
    });
  }

  /* ---------- swipe rows (chips, desktop gallery thumbs): edge fades while there is more to scroll (round 16) ---------- */
  function initEdgeFades(root) {
    all('.lw-chips, .lw-gal__thumbs', root).forEach(function (el) {
      if (!once(el, 'Fade')) return;
      var raf = 0;
      function paint() {
        raf = 0;
        var max = el.scrollWidth - el.clientWidth;
        el.classList.toggle('lw-fade-r', max > 2 && el.scrollLeft < max - 2);
        el.classList.toggle('lw-fade-l', max > 2 && el.scrollLeft > 2);
      }
      function queue() { if (!raf) raf = requestAnimationFrame(paint); }
      el.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(queue).observe(el);
      paint();
    });
  }

  /* ---------- Ken Burns on stills ([data-lw-kb]): slow zoom + drift once per entry, reset while off screen ---------- */
  var kbIO = hasIO && !reduce
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-kb', e.isIntersecting); });
      }, { threshold: 0.35 })
    : null;
  function initKenBurns(root) {
    if (!kbIO) return;
    all('[data-lw-kb]', root).forEach(function (img) { if (once(img, 'Kb')) kbIO.observe(img); });
  }

  /* ---------- smooth anchor scroll (#lw-buy, #lw-reviews) ---------- */
  function findTarget(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var id = hash.slice(1);
    return doc.getElementById(id) || doc.querySelector('[id$="__' + id.replace(/-/g, '_') + '"]');
  }
  function scrollToEl(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  function initScrollLinks(root) {
    all('[data-lw-scroll]', root).forEach(function (a) {
      if (!once(a, 'Scroll')) return;
      a.addEventListener('click', function (e) {
        var t = findTarget(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        scrollToEl(t);
      });
    });
  }

  /* ---------- gallery (color-aware: slides carry data-order-pink / data-order-olive) ---------- */
  function initGallery(g) {
    if (!once(g, 'Gallery')) return;
    var track = g.querySelector('[data-lw-track]');
    var thumbsWrap = g.querySelector('.lw-gal__thumbs');
    var fill = g.querySelector('[data-lw-progress]');
    var prev = g.querySelector('[data-lw-prev]');
    var next = g.querySelector('[data-lw-next]');
    if (!track) return;
    var slides = [], thumbs = [];
    var current = -1;

    function visible(list) { return list.filter(function (el) { return !el.hidden; }); }
    function collect() {
      slides = visible(all('[data-lw-slide]', track));
      thumbs = thumbsWrap ? visible(all('[data-lw-thumb]', thumbsWrap)) : [];
      if (fill) fill.style.setProperty('--lw-seg', (100 / Math.max(1, slides.length)) + '%');
    }
    function pad() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    function go(i, smooth) {
      if (!slides.length) return;
      i = clamp(i, 0, slides.length - 1);
      track.scrollTo({ left: slides[i].offsetLeft - pad(), behavior: smooth === false || reduce ? 'auto' : 'smooth' });
      setCurrent(i);
    }
    function setCurrent(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (fill) fill.style.setProperty('--lw-i', i);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      all('[data-lw-slide]', track).forEach(function (s) {
        var v = s.querySelector('video');
        if (!v) return;
        if (s === slides[i]) {
          delete v.dataset.lwOffslide;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          v.dataset.lwOffslide = '1';
          v.pause();
        }
      });
      var t = thumbs[i];
      if (t && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        thumbsWrap.scrollTo({ left: t.offsetLeft - 8, behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var x = track.scrollLeft + pad();
        var best = 0, bestD = Infinity;
        slides.forEach(function (s, j) {
          var d = Math.abs(s.offsetLeft - x);
          if (d < bestD) { bestD = d; best = j; }
        });
        setCurrent(best);
      });
    }, { passive: true });
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-lw-thumb]');
        if (t) go(thumbs.indexOf(t));
      });
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });

    /* swatch change: reorder + filter slides and thumbs for that color, then show the first one */
    function arrange(list, parent, attr) {
      var keyed = list.map(function (el) { return { el: el, o: parseInt(el.getAttribute(attr), 10) }; });
      keyed.filter(function (k) { return k.o >= 0; })
        .sort(function (a, b) { return a.o - b.o; })
        .forEach(function (k) { k.el.hidden = false; parent.appendChild(k.el); });
      keyed.filter(function (k) { return !(k.o >= 0); })
        .forEach(function (k) { k.el.hidden = true; parent.appendChild(k.el); });
    }
    g.addEventListener('lw:color', function (e) {
      var color = e.detail === 'olive' ? 'olive' : 'pink';
      if (g.getAttribute('data-color') === color) return;
      g.setAttribute('data-color', color);
      var attr = 'data-order-' + color;
      arrange(all('[data-lw-slide]', track), track, attr);
      if (thumbsWrap) {
        arrange(all('[data-lw-thumb]', thumbsWrap), thumbsWrap, attr);
        all('[data-lw-thumb]', thumbsWrap).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      }
      collect();
      current = -1;
      track.scrollTo({ left: 0, behavior: 'auto' });
      if (thumbsWrap) thumbsWrap.scrollTo({ left: 0, behavior: 'auto' });
      setCurrent(0);
      // make sure the new first images load right away even if they were lazy + hidden before
      slides.slice(0, 2).forEach(function (s) {
        var img = s.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    });

    all('video', g).forEach(function (v) { v.muted = true; });
    collect();
    setCurrent(0);
    if (hasIO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = slides[current] && slides[current].querySelector('video');
          if (!v) return;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 }).observe(track);
    }
  }

  /* ---------- buy box: variants, qty, sticky bar ---------- */
  function initBuy(root) {
    if (!once(root, 'Buy')) return;
    var form = root.querySelector('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var radios = all('input[data-lw-variant]', root);
    var qty = root.querySelector('[data-lw-qty-input]');
    var bundles = all('input[data-lw-bundle-qty]', root);
    var unitPrice = (root.querySelector('[data-lw-price]') || {}).textContent || '';
    var main = root.querySelector('[data-lw-atc-main]');
    var gallery = doc.querySelector('[data-lw-gallery]');
    LW.mainButton = main;

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked || !idInput) return;
        idInput.value = r.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        all('[data-lw-color-name], [data-lw-sticky-color]').forEach(function (el) { el.textContent = r.getAttribute('data-title'); });
        unitPrice = r.getAttribute('data-price');
        all('[data-lw-price]').forEach(function (el) { el.textContent = unitPrice; });
        paintBundle();
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (err) {}
        var color = r.getAttribute('data-color');
        if (gallery && color) gallery.dispatchEvent(new CustomEvent('lw:color', { detail: color }));
        if (color) doc.dispatchEvent(new CustomEvent('lw:variant-color', { detail: color }));
        var tint = r.getAttribute('data-tint');
        if (tint) root.style.setProperty('--lw-bg', tint);
      });
    });

    /* bundle selector: 1 or 2 devices -> quantity + the price shown on the buttons */
    function paintBundle() {
      var sel = bundles.filter(function (b) { return b.checked; })[0];
      var n = sel ? parseInt(sel.getAttribute('data-lw-bundle-qty'), 10) || 1 : 1;
      if (qty) qty.value = n;
      var price = n > 1 && sel.getAttribute('data-price') ? sel.getAttribute('data-price') : unitPrice;
      all('[data-lw-atc-price]').forEach(function (el) { el.textContent = price; });
      all('[data-lw-bundle-suffix]').forEach(function (el) { el.textContent = n > 1 ? ' for ' + n : ''; });
    }
    bundles.forEach(function (b) { b.addEventListener('change', paintBundle); });
    paintBundle();

    /* round 18: every buy-box message (theme form or pair add) is copied next to the proxy buttons ([data-lw-err-mirror],
       e.g. the CTA block), and the proxies show the busy state while an add is running */
    (function () {
      var ew = root.querySelector('.product-form__error-message-wrapper');
      var mirrors = all('[data-lw-err-mirror]');
      if (ew && mirrors.length && 'MutationObserver' in window) {
        var copy = function () {
          var on = !ew.hidden && ew.textContent.trim() !== '';
          mirrors.forEach(function (m) { m.hidden = !on; m.textContent = on ? ew.textContent.trim() : ''; });
        };
        new MutationObserver(copy).observe(ew, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
      }
      if (main && 'MutationObserver' in window) {
        new MutationObserver(function () {
          var busy = main.classList.contains('loading');
          all('[data-lw-atc]').forEach(function (b) { b.classList.toggle('is-loading', busy); if (busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
        }).observe(main, { attributes: true, attributeFilter: ['class'] });
      }
    })();

    /* ---------- pair colours (round 17): "2 EndoSculpts" -> Sculptor 1 + Sculptor 2, each with its own colour ----------
       Sculptor 1 IS the hero colour (two-way), so the gallery and the rest of the page keep following it; Sculptor 2 starts
       on the same colour when the pair opens and then changes only when the visitor picks it. Every pair add goes through addPair():
       same colour = one line x2, two colours = two lines (POST /cart/add.js items[]), then the theme's cart drawer renders
       exactly as after the normal add. Express checkout can only buy the form's one variant: hidden for two colours. */
    var pairBox = root.querySelector('[data-lw-pair]');
    var picks1 = all('input[data-lw-pair-pick="1"]', root), picks2 = all('input[data-lw-pair-pick="2"]', root);
    var payBtn = root.querySelector('.shopify-payment-button');
    var mixedNote = root.querySelector('[data-lw-mixed-note]');
    var stickyColor = all('[data-lw-sticky-color]');
    var errWrap = root.querySelector('.product-form__error-message-wrapper');
    var errMsg = errWrap && errWrap.querySelector('.product-form__error-message');
    var spinner = main && main.querySelector('.loading-overlay__spinner');
    function heroRadio() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    function picked(list) { var r = list.filter(function (x) { return x.checked; })[0]; return r ? r.value : null; }
    function setPick(list, id) { list.forEach(function (x) { x.checked = x.value === String(id); }); }
    function titleOf(id) { var r = radios.filter(function (x) { return x.value === String(id); })[0]; return r ? r.getAttribute('data-title') : ''; }
    function pairOn() { var sel = bundles.filter(function (b) { return b.checked; })[0]; return !!sel && sel.getAttribute('data-lw-bundle-qty') === '2'; }
    function mixed() { return pairOn() && picked(picks1) !== picked(picks2); }
    function paintPair() {
      var on = pairOn(), mx = mixed(), h = heroRadio();
      if (pairBox) pairBox.hidden = !on;
      if (payBtn) payBtn.hidden = mx;
      if (payBtn) payBtn.classList.toggle('lw-is-off', mx);
      if (mixedNote) mixedNote.hidden = !mx;
      var txt = mx ? titleOf(picked(picks1)) + ' + ' + titleOf(picked(picks2)) : (h ? h.getAttribute('data-title') : '');
      stickyColor.forEach(function (el) { el.textContent = txt; });
    }
    function showErr(msg) {
      if (!errWrap) { if (msg) window.alert(msg); return; }
      errWrap.hidden = !msg;
      if (errMsg) errMsg.textContent = msg || '';
      if (msg) {
        var mirrorInView = all('[data-lw-err-mirror]').some(function (m) { var q = m.parentNode.getBoundingClientRect(); return q.bottom > 0 && q.top < window.innerHeight; });
        var r = errWrap.getBoundingClientRect();
        if (!mirrorInView && (r.top < 60 || r.bottom > window.innerHeight - 80)) errWrap.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    if (pairBox && picks1.length && picks2.length) {
      bundles.forEach(function (b) {
        b.addEventListener('change', function () {
          if (pairOn()) {  // opening the pair: both sculptors start on the current colour
            var h = heroRadio();
            setPick(picks1, h.value); setPick(picks2, h.value);
          }
          showErr(false);
          paintPair();
        });
      });
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          setPick(picks1, r.value);
          paintPair();
        });
      });
      picks1.forEach(function (x) {
        x.addEventListener('change', function () {
          if (!x.checked) return;
          var h = radios.filter(function (r) { return r.value === x.value; })[0];
          if (h && !h.checked) { h.checked = true; h.dispatchEvent(new Event('change', { bubbles: true })); }  // gallery + page follow
          paintPair();
        });
      });
      picks2.forEach(function (x) {
        x.addEventListener('change', function () { if (x.checked) paintPair(); });
      });

      var busy = false;
      function addPair() {
        if (busy || !main || main.disabled) return;
        var a = picked(picks1), b = picked(picks2);
        if (!a || !b) { showErr('Please choose a color for both sculptors.'); return; }
        busy = true;
        showErr(false);
        main.setAttribute('aria-disabled', 'true');
        main.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        var items = a === b ? [{ id: parseInt(a, 10), quantity: 2 }] : [{ id: parseInt(a, 10), quantity: 1 }, { id: parseInt(b, 10), quantity: 1 }];
        var cart = doc.querySelector('cart-drawer') || doc.querySelector('cart-notification');
        var body = { items: items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map(function (x) { return x.id; });
          body.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(doc.activeElement);
        }
        var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            return res.json().then(function (j) { return { ok: res.ok, j: j }; }, function () { return { ok: false, j: {} }; });
          })
          .then(function (r) {
            if (!r.ok || r.j.status) {
              showErr(r.j.description || r.j.message || 'The pair could not be added to your cart. Please try again.');
              return;
            }
            if (!cart || !cart.renderContents || !r.j.sections) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
            cart.renderContents(r.j);
          })
          .catch(function () {
            showErr('Connection problem: the pair was not added. Please check your connection and try again.');
          })
          .then(function () {
            busy = false;
            main.classList.remove('loading');
            main.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          });
      }
      // capture on the <product-form> wrapper runs before the theme's own submit handler on the <form>
      var pf = form.closest('product-form') || form.parentNode;
      pf.addEventListener('submit', function (e) {
        if (!pairOn()) return;  // one sculptor: the theme's normal add, untouched
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addPair();
      }, true);
      paintPair();
    }

    /* desktop sticky gallery sits just below the header */
    if (root.hasAttribute('data-lw-sticky-media')) {
      var setTop = function () {
        var h = doc.querySelector('.section-header');
        root.style.setProperty('--lw-sticky-top', ((h ? h.offsetHeight : 0) + 16) + 'px');
      };
      setTop();
      window.addEventListener('resize', setTop, { passive: true });
    }

    var bar = root.querySelector('[data-lw-sticky]');
    if (bar && main && hasIO) {
      var pastMain = false, hideZone = false, hideAvoid = false;
      var sync = function () {
        var on = pastMain && !hideZone && !hideAvoid;
        bar.classList.toggle('is-on', on);
        if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { pastMain = !e.isIntersecting && e.boundingClientRect.top < 0; });
        sync();
      }).observe(main);
      // a jump (anchor link, restored scroll) can skip the button without an IO crossing: re-check on scroll
      var tick = 0;
      window.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = 0;
          var past = main.getBoundingClientRect().bottom < 0;
          if (past !== pastMain) { pastMain = past; sync(); }
        });
      }, { passive: true });
      // round 15: [data-lw-sticky-avoid] (before/after photo, glide map) hides the bar only while it is under the bar
      var avoid = all('[data-lw-sticky-avoid]');
      if (avoid.length) {
        var under = new Set();
        var aio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) under.add(e.target); else under.delete(e.target); });
          hideAvoid = under.size > 0;
          sync();
        }, { rootMargin: '-86% 0px 0px 0px' });
        avoid.forEach(function (z) { aio.observe(z); });
      }
      var zones = all('[data-lw-hide-sticky], footer, .footer');
      if (zones.length) {
        var visible = new Set();
        var zio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
          hideZone = visible.size > 0;
          sync();
        });
        zones.forEach(function (z) { zio.observe(z); });
      }
    }
  }

  /* ---------- buy CTA block (round 18): drives the hero's own inputs, mirrors its state ---------- */
  function initCta(sec) {
    if (!once(sec, 'Cta')) return;
    var root = doc.querySelector('[data-lw-buybox]');
    if (!root) return;  // the button stays a link to the buy box
    var radios = all('input[data-lw-variant]', root), bundles = all('input[data-lw-bundle-qty]', root);
    var sws = all('[data-lw-cta-color]', sec), sets = all('[data-lw-cta-set]', sec);
    var line = sec.querySelector('[data-lw-cta-pairline]'), pairTxt = sec.querySelector('[data-lw-cta-pair]');
    function find(list, fn) { return list.filter(fn)[0]; }
    function fire(input) {
      if (!input || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    sws.forEach(function (b) {
      b.addEventListener('click', function () { fire(find(radios, function (r) { return r.value === b.getAttribute('data-lw-cta-color'); })); });
    });
    sets.forEach(function (b) {
      b.addEventListener('click', function () { fire(find(bundles, function (x) { return x.getAttribute('data-lw-bundle-qty') === b.getAttribute('data-lw-cta-set'); })); });
    });
    function title(n) { var r = root.querySelector('input[data-lw-pair-pick="' + n + '"]:checked'); return r ? r.getAttribute('data-title') : ''; }
    function sync() {
      var h = find(radios, function (r) { return r.checked; });
      var bs = find(bundles, function (x) { return x.checked; });
      var q = bs ? bs.getAttribute('data-lw-bundle-qty') : '1';
      sws.forEach(function (b) { b.setAttribute('aria-pressed', h && b.getAttribute('data-lw-cta-color') === h.value ? 'true' : 'false'); });
      sets.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lw-cta-set') === q ? 'true' : 'false'); });
      if (line) {
        line.hidden = q !== '2';
        var a = title(1), c = title(2);
        if (pairTxt) pairTxt.textContent = a && c ? (a === c ? '2 × ' + a : a + ' + ' + c) : '';
      }
    }
    root.addEventListener('change', function () { setTimeout(sync, 0); });
    doc.addEventListener('lw:variant-color', function (e) { sec.setAttribute('data-color', e.detail === 'olive' ? 'olive' : 'pink'); });
    var h0 = find(radios, function (r) { return r.checked; });
    if (h0) sec.setAttribute('data-color', h0.getAttribute('data-color') || 'pink');
    sync();
  }

  /* any [data-lw-atc] button elsewhere on the page submits the main buy form */
  function initAtcProxies(root) {
    all('[data-lw-atc]', root).forEach(function (b) {
      if (!once(b, 'Atc')) return;
      b.addEventListener('click', function (e) {
        var main = LW.mainButton || doc.querySelector('[data-lw-atc-main]');
        if (!main || main.disabled) return;
        e.preventDefault();
        main.click();
      });
    });
  }

  /* ---------- tabs (before/after, routines, compare chips) ---------- */
  function initTabs(root) {
    all('[data-lw-tabs]', root).forEach(function (wrap) {
      if (!once(wrap, 'Tabs')) return;
      var tabs = all('[role="tab"]', wrap);
      var target = wrap.getAttribute('data-lw-tabs') ? doc.getElementById(wrap.getAttribute('data-lw-tabs')) : null;
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var pid = t.getAttribute('aria-controls');
          var panel = pid && !t.hasAttribute('data-lw-col') ? doc.getElementById(pid) : null;
          if (panel) {
            panel.hidden = !on;
            if (on) initReveal(panel);
          }
        });
        var col = tabs[i].getAttribute('data-lw-col');
        if (col && target) target.setAttribute('data-active', col);
        if (focus) tabs[i].focus();
        var tab = tabs[i];
        wrap.dispatchEvent(new CustomEvent('lw:tabchange', { bubbles: true, detail: { index: i, tab: tab } }));
        if (tab.parentNode.scrollWidth > tab.parentNode.clientWidth) {
          tab.parentNode.scrollTo({ left: tab.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
          else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
          else if (k === 'Home') { e.preventDefault(); select(0, true); }
          else if (k === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });
    });
  }

  /* ---------- before / after drag slider (round 15: mobile first) ----------
     Drag anywhere on the photo, horizontal only (touch-action: pan-y keeps vertical page scroll); keyboard via the
     hidden range; "Day 1 | Day 30" glides the divider to 100 % / 0 %; one nudge on first view (not under reduced motion). */
  function initBA(el) {
    if (!once(el, 'Ba')) return;
    var range = el.querySelector('input[type="range"]');
    var panel = el.closest('.lw-ba__panel') || el.parentNode;
    var segs = all('[data-lw-ba-go]', panel);
    var dragging = false, moved = false, startX = 0, startY = 0, cur = 50, raf = 0;
    el._lwBaTouched = false;
    function paintSeg(p) {
      segs.forEach(function (b) { b.setAttribute('aria-pressed', p !== null && parseFloat(b.getAttribute('data-lw-ba-go')) === p ? 'true' : 'false'); });
    }
    function set(p) {
      cur = p = clamp(p, 0, 100);
      el.style.setProperty('--pos', p + '%');
      if (range) { range.value = Math.round(p); range.setAttribute('aria-valuetext', Math.round(p) + '% before'); }
    }
    function tween(to, ms, done) {  // eased glide of the divider
      cancelAnimationFrame(raf);
      if (!ms) { set(to); if (done) done(); return; }
      var from = cur, t0 = performance.now();
      function step(now) {
        var k = Math.min(1, (now - t0) / ms), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        set(from + (to - from) * e);
        if (k < 1) raf = requestAnimationFrame(step); else if (done) done();
      }
      raf = requestAnimationFrame(step);
    }
    el._lwBaTween = tween;
    /* breathing (round 18): the divider swings gently around its spot until the first touch; only the visual --pos
       moves (cur stays), so a drag / tap / Day toggle always starts from what is on screen */
    var br = { on: false, raf: 0, t0: 0, vis: 50 }, BR_T = 2500, BR_A = reduce ? 2 : 7;
    function brStep(now) {
      var ramp = Math.min(1, (now - br.t0) / 900);  // eases in, no jump at the start
      var sn = Math.sin(((now - br.t0) / BR_T) * 2 * Math.PI);
      br.vis = clamp(cur + BR_A * ramp * sn, 0, 100);
      el.style.setProperty('--pos', br.vis.toFixed(2) + '%');
      el.style.setProperty('--ba-spread', (Math.abs(sn) * ramp).toFixed(3));
      br.raf = requestAnimationFrame(brStep);
    }
    el._lwBreath = {
      start: function () {
        if (br.on || el._lwBaTouched) return;
        br.on = true; br.t0 = performance.now(); br.vis = cur;
        el.classList.add('is-breathing');
        br.raf = requestAnimationFrame(brStep);
      },
      stop: function (keepVisual) {
        if (!br.on) return;
        br.on = false;
        cancelAnimationFrame(br.raf);
        if (keepVisual) cur = br.vis;  // a touch takes over from where the divider is
        el.style.setProperty('--pos', cur + '%');
        el.style.setProperty('--ba-spread', '0');
        el.classList.remove('is-breathing');
      },
      reset: function () { el._lwBaTouched = false; cancelAnimationFrame(raf); set(50); paintSeg(null); }
    };
    function user() { el._lwBaTouched = true; el._lwBreath.stop(true); cancelAnimationFrame(raf); paintSeg(null); }
    function pct(e) {
      var r = el.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * 100;
    }
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = false; startX = e.clientX; startY = e.clientY;
      if (e.pointerType === 'mouse') { user(); set(pct(e)); moved = true; }
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      if (!moved) {
        var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
        if (dx < 6) return;
        if (dy > dx) { dragging = false; return; }  // a vertical swipe belongs to the page
        moved = true;
        user();
      }
      set(pct(e));
    });
    function end(e) {
      if (dragging && !moved && e.type === 'pointerup') { user(); tween(pct(e), reduce ? 0 : 240); }
      dragging = false;
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', function () { dragging = false; });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if (range) range.addEventListener('input', function () { user(); set(parseFloat(range.value)); });
    segs.forEach(function (b) {
      b.addEventListener('click', function () {
        var to = parseFloat(b.getAttribute('data-lw-ba-go'));
        user();
        tween(to, reduce ? 0 : 420);
        paintSeg(to);
      });
    });
    set(50);
  }
  function initBASection(sec) {
    if (!once(sec, 'BaSec')) return;
    var stage = sec.querySelector('.lw-ba__stage');
    var inView = !hasIO;
    function shown() { return sec.querySelector('.lw-ba__panel:not([hidden]) [data-lw-ba]'); }
    function sync() {
      all('[data-lw-ba]', sec).forEach(function (el) {
        if (!el._lwBreath) return;
        if (inView && el === shown()) el._lwBreath.start(); else el._lwBreath.stop(false);
      });
    }
    // a newly selected tester invites play again (fresh divider, breathing on)
    sec.addEventListener('lw:tabchange', function () {
      var el = shown();
      if (el && el._lwBreath) el._lwBreath.reset();
      setTimeout(sync, 0);
    });
    if (hasIO && stage) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; sync(); });
      }, { threshold: 0.35 }).observe(stage);
    }
    sync();
  }

  /* ---------- UGC cards: tap to pause / play ---------- */
  function initUgc(card) {
    if (!once(card, 'Ugc')) return;
    var v = card.querySelector('video');
    var btn = card.querySelector('[data-lw-toggle]');
    if (!v) return;
    watchVideo(v);
    function paint() {
      var paused = v.paused;
      card.classList.toggle('is-paused', paused);
      if (btn) btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    v.addEventListener('play', paint);
    v.addEventListener('pause', paint);
    function toggle() {
      if (v.paused) {
        delete v.dataset.lwUserPaused;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else {
        v.dataset.lwUserPaused = '1';
        v.pause();
      }
    }
    if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    v.addEventListener('click', toggle);
    paint();
  }

  /* ---------- A. two-way rotation illustration ---------- */
  function initRotation(stage) {
    if (!once(stage, 'Rot')) return;
    var section = stage.closest('.lw') || doc;
    var dirBtns = all('[data-lw-dir]', section);
    var spdBtns = all('[data-lw-speed]', section);
    var status = stage.querySelector('[data-lw-rot-status]');
    function paint() {
      var dir = stage.getAttribute('data-dir');
      var spd = stage.getAttribute('data-speed');
      dirBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lw-dir') === dir ? 'true' : 'false'); });
      spdBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lw-speed') === spd ? 'true' : 'false'); });
      if (status) status.textContent = (dir === 'down' ? 'Rotating down' : 'Rotating up') + ' · speed ' + spd;
    }
    dirBtns.forEach(function (b) {
      b.addEventListener('click', function () { stage.setAttribute('data-dir', b.getAttribute('data-lw-dir')); paint(); });
    });
    spdBtns.forEach(function (b) {
      b.addEventListener('click', function () { stage.setAttribute('data-speed', b.getAttribute('data-lw-speed')); paint(); });
    });
    paint();
    if (reduce) return; // static illustration
    if (hasIO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { stage.classList.toggle('is-live', e.isIntersecting); });
      }, { threshold: 0.2 }).observe(stage);
    } else {
      stage.classList.add('is-live');
    }
  }

  /* ---------- C. count-up numbers ---------- */
  function initStats(grid) {
    if (!once(grid, 'Stats')) return;
    var nums = all('[data-lw-count]', grid);
    if (reduce || !hasIO || !nums.length) return; // final values are already in the HTML
    nums.forEach(function (n) { n.textContent = '0'; });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        nums.forEach(function (n, k) {
          var to = parseFloat(n.getAttribute('data-lw-count')) || 0;
          var dur = 1100 + k * 120;
          var t0 = null;
          function step(t) {
            if (t0 === null) t0 = t;
            var p = Math.min(1, (t - t0) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            n.textContent = String(Math.round(to * eased));
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      });
    }, { threshold: 0.4 });
    io.observe(grid);
  }

  /* ---------- photoreal spinning head (snippets/lw-bead-device, round 14): muted inline loop that plays only while its
     stack is shown and in view - also under reduced motion (small in-place product motion, owner's call). A refused
     play() (iOS Low Power Mode) leaves the poster = the static head. "Two-way rotation" cross-fades to the -rev twin,
     started at the mirrored time so the drum position matches. ---------- */
  // clips: 30 frames, 1.0 s seamless loop at constant speed; the owner wants it brisk
  var HEAD_RATE = 1.4, HEAD_REST = 0.8;  // How it's built + while dragging / Where to glide at rest
  function headPrep(v) {  // iOS: muted + playsinline must be set before play()
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
  }
  function headTry(v) {
    headPrep(v);
    var p = v.play();
    return p && p.then ? p : Promise.resolve();
  }
  function head(stack) {
    if (!stack._lwHead) {
      var h = stack._lwHead = { f: stack.querySelector('video[data-lw-head="fwd"]'), r: stack.querySelector('video[data-lw-head="rev"]'), dir: 1, rate: HEAD_RATE, on: false, primed: false };
      headWatch(h, h.f);
      headWatch(h, h.r);
      headAll.push(h);
    }
    return stack._lwHead;
  }
  function headCur(h) { return h.dir < 0 && h.r ? h.r : h.f; }
  var headAll = [];
  // the browser paused a clip we still want running (a loop wrap in some engines, a stall, back from a hidden tab):
  // start it again. A refused play() fires no pause, so Low Power Mode cannot loop here; the counter resets on progress.
  function headWatch(h, v) {
    if (!v || v._lwWatch) return;
    v._lwWatch = true;
    var n = 0;
    v.addEventListener('pause', function () {
      if (!h.on || headCur(h) !== v || doc.hidden || n > 30) return;
      n++;
      setTimeout(function () {
        if (h.on && headCur(h) === v && v.paused && !doc.hidden) headTry(v).then(null, function () {});
      }, 60);
    });
    v.addEventListener('timeupdate', function () { if (v.currentTime > 0.3) n = 0; });
  }
  doc.addEventListener('visibilitychange', function () {
    if (doc.hidden) return;
    headAll.forEach(function (h) { var v = headCur(h); if (h.on && v.paused) headTry(v).then(null, function () {}); });
  });
  function headPrime(h) {  // after the first play: load the reversed twin so a flip has data (play + pause works on iOS)
    h.primed = true;
    h.r.preload = 'auto';
    if (h.r.readyState >= 2) return;
    headTry(h.r).then(function () { if (headCur(h) !== h.r) h.r.pause(); }, function () {});
  }
  function headRun(stack, on) {
    var h = head(stack);
    if (!h.f) return;
    h.on = on;
    var v = headCur(h), o = v === h.f ? h.r : h.f;
    if (o) o.pause();
    if (!on) { v.pause(); return; }
    v.playbackRate = h.rate;
    headTry(v).then(function () {
      v.playbackRate = h.rate;
      if (h.r && !h.primed) headPrime(h);
    }, function () {});
  }
  function headRate(stack, r, exact) {
    var h = head(stack), v = headCur(h);
    h.rate = r;
    if (v && (exact ? v.playbackRate !== r : Math.abs(v.playbackRate - r) > 0.04)) v.playbackRate = r;  // a few steps per ramp
  }
  function headDir(stack, dir) {
    var h = head(stack);
    if (!h.r || h.dir === dir) { h.dir = dir; return; }
    var from = headCur(h);
    h.dir = dir;
    var to = headCur(h);
    var D = from.duration || to.duration || 1;
    var t = (1 - from.currentTime / D) * D % D;  // the twin is the exact reverse (rev frame k = fwd frame 29 - k): mirrored time
    headPrep(to);
    to.playbackRate = h.rate;
    var swapped = false, started = false;
    function swap() {
      if (swapped) return;
      swapped = true;
      to.classList.add('is-on');
      from.classList.remove('is-on');
      setTimeout(function () { if (headCur(h) !== from) from.pause(); }, 260);  // after the 200 ms fade (lw.css)
    }
    try { to.currentTime = t; } catch (err) {}
    if (!h.on) { from.pause(); swap(); return; }  // not running: just switch, the twin starts on the next entry
    function go() {
      if (started) return;
      started = true;
      headTry(to).then(swap, swap);
    }
    if (to.readyState >= 1 && to.seeking) to.addEventListener('seeked', go, { once: true });
    else go();
    setTimeout(function () { go(); setTimeout(swap, 120); }, 450);  // never hang on a slow seek
  }

  /* ---------- B. glide map: highlights, routines, attachment chips, desktop product loop ---------- */
  function initGlide(map) {
    if (!once(map, 'Glide')) return;
    var section = map.closest('[data-lw-ritual]') || map;
    var groups = all('[data-lw-glide-grp]', map);
    var btns = all('[data-lw-glide-btn]', map);
    var cap = map.querySelector('[data-lw-glide-caption]');
    var defaultCap = cap ? cap.getAttribute('data-default') || cap.textContent : '';
    var attBtns = all('[data-lw-gm-att]', map);
    var card = section.querySelector('[data-lw-rt-video]');
    var kindLabel = section.querySelector('[data-lw-kind-label]');
    var st = { att: map.getAttribute('data-att') || 'wave', color: map.getAttribute('data-color') || 'pink' };
    var locked = { list: [], text: '' };
    var routine = { list: [], text: '' };

    function captionFor(list) {
      return list.map(function (n) {
        var b = map.querySelector('[data-lw-glide-btn="' + n + '"]');
        return b ? n + '. ' + b.getAttribute('data-caption') : '';
      }).join(' ');
    }
    function render(list, text) {
      map.classList.toggle('has-active', list.length > 0);
      groups.forEach(function (g) {
        g.classList.toggle('is-active', list.indexOf(g.getAttribute('data-lw-glide-grp')) > -1);
      });
      btns.forEach(function (b) {
        var n = b.getAttribute('data-lw-glide-btn');
        b.setAttribute('aria-pressed', locked.list.length === 1 && locked.list[0] === n ? 'true' : 'false');
        b.classList.toggle('is-preview', list.length === 1 && list[0] === n);
      });
      if (cap) {
        cap.textContent = text || defaultCap;
        cap.classList.remove('is-swap');
        void cap.offsetWidth;
        cap.classList.add('is-swap');
      }
    }
    function lock(list, text) { locked = { list: list, text: text }; render(list, text); }
    function restore() { render(locked.list, locked.text); }

    btns.forEach(function (b) {
      var n = b.getAttribute('data-lw-glide-btn');
      var label = n + '. ' + (b.getAttribute('data-caption') || '');
      b.addEventListener('click', function () {
        if (locked.list.length === 1 && locked.list[0] === n) lock(routine.list, routine.text);
        else lock([n], label);
      });
      b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') render([n], label); });
      b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') restore(); });
      b.addEventListener('focus', function () {
        var kb = true;
        try { kb = b.matches(':focus-visible'); } catch (err) {}
        if (kb) render([n], label);
      });
      b.addEventListener('blur', restore);
    });

    /* attachment + color: draggable device variant and the desktop product loop */
    function paint() {
      map.setAttribute('data-att', st.att);
      map.setAttribute('data-color', st.color);
      all('.lw-gm__v', map).forEach(function (v) {
        v.hidden = !(v.getAttribute('data-color') === st.color && v.getAttribute('data-att') === st.att);
      });
      attBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lw-gm-att') === st.att ? 'true' : 'false'); });
      if (card) {
        var shown = card.offsetParent !== null;  // display: none below 990 px: load nothing there
        all('[data-kind]', card).forEach(function (v) {
          var on = v.getAttribute('data-kind') === st.att && v.getAttribute('data-color') === st.color;
          v.hidden = !on;
          if (v.tagName !== 'VIDEO') return;  // the spheres card is a still image
          if (!on) v.pause();
          else if (shown) setPoster(v);  // never blank on a swap
        });
      }
      if (kindLabel) kindLabel.textContent = st.att === 'spheres' ? 'Cooling Spheres' : 'Wave Roller';
      map.dispatchEvent(new CustomEvent('lw:drag-variant'));
    }
    attBtns.forEach(function (b) {
      b.addEventListener('click', function () { st.att = b.getAttribute('data-lw-gm-att'); paint(); });
    });
    function fromTab(tab, setAtt) {
      if (!tab) return;
      var list = (tab.getAttribute('data-lw-paths') || '').split(',').filter(Boolean);
      routine = { list: list, text: captionFor(list) };
      lock(routine.list, routine.text);
      var k = tab.getAttribute('data-lw-kind');
      if (setAtt && k) { st.att = k; paint(); }
    }
    section.addEventListener('lw:tabchange', function (e) { fromTab(e.detail && e.detail.tab, true); });
    doc.addEventListener('lw:variant-color', function (e) { st.color = e.detail === 'olive' ? 'olive' : 'pink'; paint(); });
    fromTab(section.querySelector('[role="tab"][aria-selected="true"]'), false);
    paint();

    /* draw-in of the lines (visual only) */
    if (reduce || !hasIO) return;
    var lines = all('.lw-gm__line', map);
    var paths = all('.lw-gm__path', map);
    var arrows = all('.lw-gm__arrow', map);
    try {
      lines.forEach(function (el, i) {
        el.style.setProperty('--l', Math.ceil(el.getTotalLength()) + 1);
        el.style.setProperty('--d', (i * 0.04).toFixed(2) + 's');
      });
      paths.forEach(function (el) {
        var g = el.closest('[data-lw-glide-grp]');
        var k = g ? parseInt(g.getAttribute('data-lw-glide-grp'), 10) : 1;
        el.style.setProperty('--l', Math.ceil(el.getTotalLength()) + 1);
        el.style.setProperty('--d', (0.5 + (k - 1) * 0.25).toFixed(2) + 's');
      });
      arrows.forEach(function (el) {
        var g = el.closest('[data-lw-glide-grp]');
        var k = g ? parseInt(g.getAttribute('data-lw-glide-grp'), 10) : 1;
        el.style.setProperty('--d', (1.4 + (k - 1) * 0.25).toFixed(2) + 's');
      });
    } catch (err) { return; }
    map.classList.add('is-ready');
    var drawIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        map.classList.add('is-drawn');
        drawIO.disconnect();
      });
    }, { threshold: 0.2 });
    drawIO.observe(map);
  }

  /* ---------- 1+2. "How it's built": callouts draw in, attachment + color crossfade, bead direction ---------- */
  function initAnatomy(sec) {
    if (!once(sec, 'Anat')) return;
    var imgs = all('[data-lw-cut]', sec);
    var chips = all('[data-lw-att]', sec);
    var descs = all('[data-lw-att-desc]', sec);
    var dirBtns = all('[data-lw-dir-toggle]', sec);
    var st = {
      att: (chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0] || { getAttribute: function () { return 'wave'; } }).getAttribute('data-lw-att'),
      color: sec.getAttribute('data-color') || 'pink',
      rate: 1, raf: 0
    };
    function pick() {
      function find(color, att) {
        return imgs.filter(function (i) { return i.getAttribute('data-color') === color && i.getAttribute('data-att') === att; })[0];
      }
      return find(st.color, st.att) || find('pink', st.att) || find(st.color, 'wave') || imgs[0];
    }
    function show() {
      var on = pick();
      imgs.forEach(function (i) {
        var active = i === on;
        i.classList.toggle('is-on', active);
        i.setAttribute('aria-hidden', active ? 'false' : 'true');
        all('img[loading="lazy"]', i.tagName === 'IMG' ? i.parentNode : i).forEach(function (im) { if (active) im.loading = 'eager'; });
        if (active && i.loading === 'lazy') i.loading = 'eager';
      });
      all('[data-lw-cut-set]', sec).forEach(function (g) {
        g.classList.toggle('is-on', !!on && g.getAttribute('data-color') === on.getAttribute('data-color') && g.getAttribute('data-att') === on.getAttribute('data-att'));
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-lw-att') === st.att ? 'true' : 'false'); });
      descs.forEach(function (d) { d.hidden = d.getAttribute('data-lw-att-desc') !== st.att; });
      sec.setAttribute('data-att', st.att);
      sec.setAttribute('data-color', st.color);
      syncHeads();
    }
    // the shown Wave Roller stack plays while the section is in view; the others rest (paused)
    var inView = !hasIO;
    function syncHeads() {
      all('.lw-bead', sec).forEach(function (b) { headRun(b, inView && b.classList.contains('is-on')); });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { st.att = c.getAttribute('data-lw-att'); show(); });
    });
    doc.addEventListener('lw:variant-color', function (e) { st.color = e.detail === 'olive' ? 'olive' : 'pink'; show(); });

    /* "Two-way rotation": every head stack switches to its reversed twin (the shown one cross-fades, lw.css) */
    dirBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var down = sec.getAttribute('data-dir') !== 'down';
        sec.setAttribute('data-dir', down ? 'down' : 'up');
        dirBtns.forEach(function (x) { x.setAttribute('aria-pressed', down ? 'true' : 'false'); });
        all('.lw-bead', sec).forEach(function (stack) { headDir(stack, down ? -1 : 1); });
      });
    });
    show();

    // head video + fx run only while the section is (nearly) on screen
    if (hasIO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          sec.classList.toggle('is-idle', !e.isIntersecting);
          inView = e.isIntersecting;
          syncHeads();
        });
      }, { rootMargin: '100px 0px' }).observe(sec);
    }

    // connectors + labels: draw when in view; reduced motion / no IO = final state immediately
    all('.lw-anat__line', sec).forEach(function (l) {
      try { l.style.setProperty('--l', Math.ceil(l.getTotalLength()) + 1); } catch (err) {}
    });
    if (reduce || !hasIO) { sec.classList.add('is-drawn'); return; }
    sec.classList.add('is-armed');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        sec.classList.add('is-drawn');
        io.disconnect();
      });
    }, { threshold: 0.3 });
    io.observe(sec.querySelector('.lw-anat__stage') || sec);
  }

  /* ---------- 3. "Glide it yourself": drag the device over the glide map, glow + lift, soft fading trail ---------- */
  var TRAIL_MS = 1200, TRAIL_MAX = 90, TRAIL_STEP_MS = 16;
  function initGlideDrag(map) {
    if (!once(map, 'Drag')) return;
    var stage = map.querySelector('.lw-gm__stage');
    var dev = map.querySelector('[data-lw-drag]');
    var canvas = map.querySelector('[data-lw-trail]');
    var hint = map.querySelector('[data-lw-drag-hint]');
    if (!stage || !dev || !canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var pts = [], raf = 0, lastAdd = 0, dragging = false, id = null, used = false;
    var head = { x: 0.62, y: 0.35 };
    var home = { x: 0, y: 0 }, pos = { x: 0, y: 0 }, grab = { x: 0, y: 0 };
    var RGB = { pink: '232,164,178', olive: '122,127,85' };

    function readHead() {
      var v = map.querySelector('.lw-gm__v:not([hidden])');
      if (!v) return;
      head.x = parseFloat(v.getAttribute('data-head-x')) || head.x;
      head.y = parseFloat(v.getAttribute('data-head-y')) || head.y;
    }
    function size() {
      var w = stage.clientWidth, h = stage.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      // start position from lw.css (--home-x / --home-y, fractions of the stage): right of the face, clear of markers and arrows
      var cs = getComputedStyle(dev);
      var hx = parseFloat(cs.getPropertyValue('--home-x')), hy = parseFloat(cs.getPropertyValue('--home-y'));
      home.x = isNaN(hx) ? w - dev.offsetWidth - 2 : w * hx;
      home.y = isNaN(hy) ? h - dev.offsetHeight - 2 : h * hy;
      if (!dragging && !used) place(home.x, home.y);
    }
    function place(x, y) {
      pos.x = x; pos.y = y;
      // left/top, not a transform: a transformed wrapper would isolate the head video's blend from the line art (round 14)
      dev.style.left = x.toFixed(1) + 'px';
      dev.style.top = y.toFixed(1) + 'px';
    }
    function draw(now) {
      ctx.clearRect(0, 0, stage.clientWidth, stage.clientHeight);
      var life = reduce ? TRAIL_MS / 2 : TRAIL_MS;
      pts = pts.filter(function (p) { return now - p.t < life; });
      var rgb = RGB[map.getAttribute('data-color') === 'olive' ? 'olive' : 'pink'];
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i], a = 1 - (now - p.t) / life;
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        g.addColorStop(0, 'rgba(' + rgb + ',' + (0.55 * a).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(' + rgb + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      }
      raf = pts.length || dragging ? requestAnimationFrame(draw) : 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(draw); }
    function addPoint(now) {
      if (now - lastAdd < TRAIL_STEP_MS) return;  // <= ~60 points per second
      lastAdd = now;
      pts.push({ x: pos.x + dev.offsetWidth * head.x, y: pos.y + dev.offsetHeight * head.y, r: Math.max(18, stage.clientWidth * 0.066), t: now });
      if (pts.length > TRAIL_MAX) pts.shift();
      kick();
    }
    /* head video: x0.8 at rest, x1.4 while dragging, eased between the two; plays only while the map is in view */
    var spin = { cur: HEAD_REST, raf: 0 }, REST = HEAD_REST, gmInView = !hasIO;
    function heads() { return all('.lw-bead', map); }
    function syncDrag() {
      heads().forEach(function (b) { headRate(b, spin.cur, true); headRun(b, gmInView && !b.hidden); });
    }
    function spinTo(target) {
      cancelAnimationFrame(spin.raf);
      var from = spin.cur, t0 = performance.now(), D = 400;
      function step(now) {
        var p = Math.min(1, (now - t0) / D);
        spin.cur = p < 1 ? from + (target - from) * (1 - Math.pow(1 - p, 3)) : target;
        heads().forEach(function (b) { if (!b.hidden) headRate(b, spin.cur, p >= 1); });
        if (p < 1) spin.raf = requestAnimationFrame(step);
      }
      spin.raf = requestAnimationFrame(step);
    }
    function firstUse() {
      if (used) return;
      used = true;
      map.classList.add('is-used');
      if (hint) hint.classList.add('is-gone');
    }
    dev.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      dragging = true; id = e.pointerId;
      try { (e.target && e.target.setPointerCapture ? e.target : dev).setPointerCapture(id); } catch (err) {}
      var r = stage.getBoundingClientRect();
      grab.x = e.clientX - r.left - pos.x; grab.y = e.clientY - r.top - pos.y;
      dev.classList.add('is-dragging');
      map.classList.add('is-dragging');
      firstUse();
      spinTo(HEAD_RATE);
    });
    dev.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== id) return;
      var r = stage.getBoundingClientRect();
      var x = clamp(e.clientX - r.left - grab.x, -dev.offsetWidth * 0.3, r.width - dev.offsetWidth * 0.7);
      var y = clamp(e.clientY - r.top - grab.y, -dev.offsetHeight * 0.3, r.height - dev.offsetHeight * 0.7);
      place(x, y);
      addPoint(performance.now());
    });
    function end(e) {
      if (!dragging || (e && e.pointerId !== id)) return;
      dragging = false; id = null;
      dev.classList.remove('is-dragging');
      map.classList.remove('is-dragging');
      spinTo(REST);
    }
    dev.addEventListener('pointerup', end);
    dev.addEventListener('pointercancel', end);
    dev.addEventListener('lostpointercapture', end);
    dev.addEventListener('keydown', function (e) {
      var d = { ArrowLeft: [-12, 0], ArrowRight: [12, 0], ArrowUp: [0, -12], ArrowDown: [0, 12] }[e.key];
      if (!d) return;
      e.preventDefault();
      firstUse();
      place(clamp(pos.x + d[0], -dev.offsetWidth * 0.3, stage.clientWidth - dev.offsetWidth * 0.7), clamp(pos.y + d[1], -dev.offsetHeight * 0.3, stage.clientHeight - dev.offsetHeight * 0.7));
      addPoint(performance.now() + TRAIL_STEP_MS);
    });
    map.addEventListener('lw:drag-variant', function () {
      readHead();
      syncDrag();  // the newly shown variant takes over playback at the current speed
    });
    window.addEventListener('resize', size, { passive: true });
    readHead();
    size();
    if (hasIO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { gmInView = e.isIntersecting; syncDrag(); });
      }, { rootMargin: '100px 0px' }).observe(stage);
    }
    syncDrag();
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(stage);
  }

  /* ---------- marquee: pause/play button (hover pause is CSS) ---------- */
  function initMarquee(m) {
    if (!once(m, 'Mq')) return;
    var btn = m.querySelector('[data-lw-mq-toggle]');
    if (!btn) return;
    function paint(paused) {
      m.classList.toggle('is-paused', paused);
      m.classList.toggle('is-playing', !paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play scrolling text' : 'Pause scrolling text');
    }
    paint(reduce);  // reduced motion: starts still, the visitor can still press play
    btn.addEventListener('click', function () { paint(!m.classList.contains('is-paused')); });
  }

  /* ---------- color-matched media ([data-lw-color-swap] > [data-color]); hidden videos pause via videoIO ---------- */
  doc.addEventListener('lw:variant-color', function (e) {
    var color = e.detail === 'olive' ? 'olive' : 'pink';
    all('[data-lw-color-swap]').forEach(function (box) {
      all('[data-color]', box).forEach(function (el) {
        el.hidden = el.getAttribute('data-color') !== color;
        var v = el.hidden && el.querySelector('video');
        if (v) v.pause();
      });
    });
  });

  /* ---------- init ---------- */
  function init(root) {
    root = root || doc;
    initReveal(root);
    lazyPosters(root);
    initOnce(root);
    initSwipePlay(root);
    initEdgeFades(root);
    initKenBurns(root);
    initScrollLinks(root);
    all('[data-lw-gallery]', root).forEach(initGallery);
    all('[data-lw-buybox]', root).forEach(initBuy);
    all('[data-lw-cta]', root).forEach(initCta);
    initAtcProxies(root);
    initTabs(root);
    all('[data-lw-ba]', root).forEach(initBA);
    all('[data-lw-ba-sec]', root).forEach(initBASection);
    all('[data-lw-ugc]', root).forEach(initUgc);
    all('[data-lw-rot]', root).forEach(initRotation);
    all('[data-lw-stats]', root).forEach(initStats);
    all('[data-lw-glide]', root).forEach(initGlide);
    all('[data-lw-marquee]', root).forEach(initMarquee);
    all('[data-lw-anatomy]', root).forEach(initAnatomy);
    all('[data-lw-glide]', root).forEach(initGlideDrag);
    all('video[data-lw-autoplay]', root).forEach(function (v) {
      if (v.closest('[data-lw-gallery]')) return; // gallery manages its own video
      watchVideo(v);
    });
  }
  LW.init = init;

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
